import '.a{display:inline-flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.ap{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { Text } from '../typography/Text'

export type BreadcrumbLevel = {
  label: string
  onClick?: () => void
}

export type BreadcrumbsProps = {
  levels: BreadcrumbLevel[]
}

export const Breadcrumbs = ({ levels }: BreadcrumbsProps) => {
  const renderedLevels = levels.flatMap((level, index) => {
    const isLast = levels.length === index + 1
    const crumb = (
      <styled.div key={index} onClick={isLast ? undefined : level.onClick}>
        {renderText(level.label, isLast)}
      </styled.div>
    )

    return isLast ? crumb : [crumb, renderText('/', false, `s${index}`)]
  })

  return (
    <div className="a b ap"
    >
      {renderedLevels}
    </div>
  )
}

const renderText = (text: string, isLast: boolean, key?: string) => {
  return (
    <div key={key}>
      <Text.Medium
        style={{
          fontFamily: 'FunnelDisplay',
          fontWeight: isLast ? 600 : 400,
          color: isLast ? 'var(--primary-blue)' : 'var(--shades-blue-300)',
          cursor: isLast ? 'default' : 'pointer',
        }}
      >
        {text}
      </Text.Medium>
    </div>
  )
}
